/**
 * Caption-Slide auto-fit
 *
 * Scans for elements marked `data-caption-slide-fit` (the .card__text-parent of
 * a Centered Caption Slide) and scales the inner .card__text down via
 * transform when its natural height exceeds the parent's available height.
 * Keeps captions + title fully visible while preserving vertical centering.
 */
(function () {
  function setup(container) {
    var target = container.querySelector('.slideshow-horizontal-caption-list__text');
    if (!target) return;

    var scheduled = false;

    function fit() {
      target.style.setProperty('--text-fit-scale', '1');

      var style = window.getComputedStyle(container);
      var paddingTop = parseFloat(style.paddingTop) || 0;
      var paddingBottom = parseFloat(style.paddingBottom) || 0;
      var containerHeight = container.clientHeight - paddingTop - paddingBottom;
      if (containerHeight <= 0) return;

      // scrollHeight reports the unscaled content height — transform doesn't
      // affect this measurement, so re-runs stay stable.
      var contentHeight = target.scrollHeight;
      if (contentHeight <= 0) return;

      if (contentHeight <= containerHeight) {
        target.style.setProperty('--text-fit-scale', '1');
        return;
      }

      var scale = containerHeight / contentHeight;
      target.style.setProperty('--text-fit-scale', scale.toFixed(4));
    }

    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        fit();
      });
    }

    if (typeof ResizeObserver !== 'undefined') {
      var observer = new ResizeObserver(schedule);
      observer.observe(container);
      observer.observe(target);
    } else {
      window.addEventListener('resize', schedule);
    }

    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(schedule);
    }

    if (document.readyState !== 'complete') {
      window.addEventListener('load', schedule, { once: true });
    }

    schedule();
  }

  function init() {
    var containers = document.querySelectorAll('[data-caption-slide-fit]');
    for (var i = 0; i < containers.length; i++) {
      if (containers[i].dataset.captionSlideFitInit === '1') continue;
      containers[i].dataset.captionSlideFitInit = '1';
      setup(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify Theme Editor section loads/reloads.
  if (typeof document !== 'undefined') {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', init);
    document.addEventListener('shopify:block:select', init);
  }
})();
